import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as XSellLoader } from 'images/x-sell-loader.svg';
import { RoutePath } from 'enums/Routes';
import { getApplicationData } from 'selectors/getApplicationData';
import StateContainer from 'components/StateContainer';
import { getMethodAuthData } from 'selectors/methodAuth';
import { FlowComponentType } from 'routes/types';

import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import useLoanOfferProcessor from 'hooks/useLoanOfferProcessor';
import { useNavigate, useNavigationType } from 'hooks/useNavigate';
import { updateLoanOffer } from 'thunks';

import { getCheckupProgress } from './Analyzing';

import styles from './Analyzing.module.scss';

const AnalyzingUpdatedOffer = ({ handleNext }: FlowComponentType): JSX.Element => {
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const { processLoanOffer } = useLoanOfferProcessor({ handleNext });
  const { application } = useSelector(getApplicationData);

  const [progress, setProgress] = useState(0);

  const { entityId } = useSelector(getMethodAuthData);

  useEffect(() => {
    if (navigationType === 'POP') {
      navigate(RoutePath.FinancialDashboard);
      return;
    }

    const runLoanOfferWithVerifiedIncome = async () => {
      setProgress(10);
      const loanOfferResponse = await dispatchWithUnwrap(
        updateLoanOffer({
          applicationId: application!.id,
          updateCallback: (data) => {
            setProgress(getCheckupProgress(data));
          },
        }),
      );
      setProgress(100);
      return loanOfferResponse;
    };

    processLoanOffer(runLoanOfferWithVerifiedIncome);
  }, [entityId]);

  return (
    <div className={styles.container}>
      <StateContainer icon={<XSellLoader />} progress={progress} title="Updating your offer..." />
    </div>
  );
};

export default AnalyzingUpdatedOffer;
